document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('[name="media-grid-toggle"]').forEach(button => {
    const section = button.closest('[id^="media-grid-"]');
    if (!section) return;

    const hiddenItems = section.querySelectorAll(".media-grid__item[data-index]:nth-child(n+4)");
    const showMoreText = section.dataset.showMoreText;
    const showLessText = section.dataset.showLessText;
    let expanded = false;

    button.textContent = showMoreText;

    button.addEventListener("click", () => {
      if (!expanded) {
        hiddenItems.forEach(item => item.classList.add("media-grid__item--visible"));
        button.textContent = showLessText;
        expanded = true;
      } else {
        hiddenItems.forEach(item => item.classList.remove("media-grid__item--visible"));
        button.textContent = showMoreText;
        expanded = false;
        window.scrollTo({ top: section.offsetTop, behavior: "smooth" });
      }
    });
  });
});
